import * as React from 'react';
import {
  TextField,
  Show,
  SimpleShowLayout,
  DateField,
  ImageField,
} from 'react-admin';

export const AdsShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <ImageField source="image" />
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="description" />
      <TextField source="url" />
      <TextField source="viewed" />
      <TextField source="clicked" />
      <DateField source="createdAt" />
    </SimpleShowLayout>
  </Show>
);
